import { jsx } from "@emotion/react/jsx-runtime";
import { Breadcrumbs as Breadcrumbs$1 } from "@mui/material";
import { forwardRef } from "react";
import { MoreHorizontal } from "react-feather";
import { breadcrumbLinkStyles, rootStyles } from "./Breadcrumb.styles.js";
import { Link } from "../Link/Link.js";
import { Typography } from "../Typography/Typography.js";
const slots = {
  CollapsedIcon: MoreHorizontal
};
const Breadcrumbs = ({
  separator = /* @__PURE__ */ jsx(Typography, { variant: "bodyMd", children: "/" }),
  ...props
}) => {
  return /* @__PURE__ */ jsx(Breadcrumbs$1, { separator, slots, css: rootStyles, ...props });
};
const BreadcrumbLink = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(Link, { css: breadcrumbLinkStyles, underline: "none", variant: "bodyMd", color: "inherit", ref, ...props });
});
export {
  BreadcrumbLink,
  Breadcrumbs
};
//# sourceMappingURL=Breadcrumbs.js.map
